import underConstructionStyles from './under-construction.styles.css?inline';
import { LitElement, html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { write } from '../language/lang';

@customElement('under-construction')
export class UnderConstruction extends LitElement {
  static styles = unsafeCSS(underConstructionStyles);

  render() {
    return html`
      <div class="under-construction">
        <p>
          ${write`This page is currently under construction. Please check back later for updates!`}
        </p>
        <img
          src="/assets/images/under-construction.webp"
          alt="Under Construction"
          class="restricted-size"
        />
      </div>
    `;
  }
}
